module.exports = __webpack_public_path__ + "static/media/expand.cdfc0d07.svg";